(function ($) {
    /* eslint-disable */

    var $header = $('.header');
    var headerHeight = $header.innerHeight();
    var $navItem = $('.item', '.nav-anchor__holder');
    var $dropdownItem = $('.dropdown-item');


    function scrollToAnchor (item) {
        item.on('click', function (e) {
            if (this.hash !== "") {
                e.preventDefault();
                var hash = this.hash;
                var indent = $(hash).offset().top - headerHeight;

                scrollTo(indent, hash);
            }
        });
    }

    function scrollTo(indent, hash) {
        $('html, body').animate({
            scrollTop: indent
        }, 2000, function() {
            history.pushState(false, document.title, hash);
        });
    }

    function hashScroll() {
        if (window.location.hash) {
            var hash = window.location.hash;
            if (hash !== "" && hash !== "#") {
                if ($(hash).length) {
                    $(window).on('load', function() {
                        var indent = $(hash).offset().top - headerHeight;

                        scrollTo(indent, hash);
                    });

                }
            }
        }
    }

    hashScroll();


    scrollToAnchor($navItem);
    scrollToAnchor($dropdownItem);


})( jQuery );

